import { Reaction } from '@/models/Reaction';
import { User, UserFromApi } from '@/models/User';

export type MessageId = string;

export type Message = {
  id: MessageId;
  sender: User;
  timestamp: number;
  strippedText: string; // llm output with entity tags removed
  structuredText: string; // llm output formatted as valid xml tree string
  text: string; // raw llm output, may contain natural language and entity tags
  threadId: string;
  metadata?: any; // TODO: determine what other attachments a message may have
  viewerReaction: Reaction | null;
  hasToolCalls: boolean;
};

export type NewMessage = Omit<Message, 'id'>;

export type MessageFromApi = {
  id: string;
  sender: UserFromApi;
  stripped_text: string;
  structured_text: string;
  text: string;
  timestamp: number;
  viewer_reaction?: string | null;
  has_tool_calls: boolean;
};

export function getMessageFromApi(
  threadId: string,
  args: MessageFromApi,
): Message {
  const viewerReaction =
    args.viewer_reaction &&
    Object.values(Reaction).includes(args.viewer_reaction as Reaction)
      ? (args.viewer_reaction as Reaction)
      : null;
  return {
    id: args.id,
    sender: {
      uuid: args.sender.uuid,
      displayName: args.sender.display_name,
    },
    timestamp: new Date(args.timestamp).getTime(),
    strippedText: args.stripped_text,
    structuredText: args.structured_text,
    text: args.text,
    threadId: threadId,
    viewerReaction,
    hasToolCalls: args.has_tool_calls,
  };
}
